import { CommonModule, DatePipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { NavigateEvaluationService } from 'src/app/navigate-evaluation.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-add-evaluation',
  templateUrl: './add-evaluation.component.html',
  styleUrls: ['./add-evaluation.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class AddEvaluationComponent implements OnInit {
  private navigationStack: string[] = [];
  minValues: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  maxValues: number[] = [15, 15, 5, 20, 10, 5, 5, 5, 5, 5, 5, 5];
  public showSpinner = true;
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  kpValues: any[] = [];
  rating: any[] = [];
  pm_rating: any[] = [];

  data: any;
  band1 = false;
  band2 = false;
  band3 = false;
  band4 = false;
  ratingValue: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  user: any;
  latestData: any;
  user_role: any;
  roleType: any;
  evaluation: any;
  publishValue = 0;
  ev_date: any;
  userInput = '';
  totalRating1: any;

  constructor(private evaluationService: EvaluationService,
    private route: ActivatedRoute,
    private navigationEvaluationService: NavigateEvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    public datepipe: DatePipe,
    private location: Location,

    private router: Router) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    this.user_detail();
    this.data = {
      data: JSON.parse(this.route.snapshot.queryParams.data),
      evaluation: JSON.parse(this.route.snapshot.queryParams.evaluation)
    }

    if (this.data != null) {
      this.latestData = this.data.evaluation && this.data.evaluation.length > 0 ? this.data.evaluation[this.data.evaluation.length - 1] : 0;
      this.rating = Array(12).fill(0);
      this.pm_rating = Array(12).fill(0);

      if (this.roleType === "Admin") {
        this.pm_rating.forEach((value, index) => {
          this.pm_rating[index] = value;
        });
        this.onInputChange();
      }
      if (this.roleType === "Team_Lead") {
        this.rating.forEach((value, index) => {
          this.rating[index] = value;
        });
        this.onInputChangeRating();
      }

    }
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
    // this.evaluationService.getKPVList(this.data.data.id).then(response => {

    this.evaluationService.getKPVList(this.data.data.id).then(response => {
      if (response) {
        this.kpValues = response.data.map((item: any) => ({
          title: item.title,
          value: item.value.replace('%', '') // Remove % sign from value
        }));
        this.showSpinner = false; // Hide spinner after data is loaded
      }
    }).catch(error => {
      console.error('Error fetching kpValues:', error);
      this.showSpinner = false; // Ensure spinner is hidden on error
      // Handle error as needed

    });
  }
  maxValueForInput(value: string): number {
    const numericValue = parseFloat(value.replace('%', ''));
    return isNaN(numericValue) ? Number.POSITIVE_INFINITY : numericValue;
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

    this.navigationStack.push('page1');
  }

  onInputChange() {
    this.pm_rating.forEach((value, index) => {
      if (!value || value === '') {
        this.pm_rating[index] = 0;
      } else {
        this.pm_rating[index] = value;
      }
    });

    this.updateTotalRating();
  }
  onInputChangeRating() {
    this.rating.forEach((value, index) => {
      if (!value || value === '') {
        this.rating[index] = 0;
      } else {
        this.rating[index] = value;
      }
    });


    this.updateTotalRating();
  }
  removePercentage(value: string): string {
    return value.replace(/[^\d.-]/g, '');
  }
  updateTotalRating() {
    if (this.roleType === "Admin") {
      this.totalRating1 = this.pm_rating.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0);
    } else if (this.roleType === "Team_Lead") {
      this.totalRating1 = this.rating.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0);
    }

    if (this.totalRating1 <= 25) {

      this.band1 = true;
      this.band2 = false;
      this.band3 = false;
      this.band4 = false;
    }
    else if (this.totalRating1 > 25 && this.totalRating1 <= 50) {

      this.band1 = false;
      this.band2 = true;
      this.band3 = false;
      this.band4 = false;
    }
    else if (this.totalRating1 > 50 && this.totalRating1 <= 75) {

      this.band1 = false;
      this.band2 = false;
      this.band3 = true;
      this.band4 = false;
    }
    else if (this.totalRating1 > 75) {

      this.band1 = false;
      this.band2 = false;
      this.band3 = false;
      this.band4 = true;
    }



  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  cancel() {
    this.router.navigate(['/evaluation-list']);
  }
  onSubmit(form: NgForm) {
    const formData = form.value;
    const publish = formData.publish;
    this.rating = [];
    for (let i = 0; i < 10; i++) {
      // Initialize each rating value; use 0 if undefined
      this.rating.push(parseInt(formData['rating' + i]) || 0);
    }

    this.pm_rating = [];
    for (let i = 0; i < 10; i++) {
      // Initialize each pm_rating value; use 0 if undefined
      this.pm_rating.push(parseInt(formData['pm_rating' + i]) || 0);
    }

    // Calculate points
    const points = (this.rating.every(value => value === 0)) ? 0 :
      this.rating.reduce((partial_sum, a) => partial_sum + a, 0) / 10;

    // Calculate pm_points
    const pm_points = this.pm_rating.reduce((partial_sum1, a) => partial_sum1 + a, 0) / 10 || 0;
    let model: any = {};
    if (this.data.evaluation != null) {
      const date = new Date(formData.ev_date);

      model = {

        month_int: date.getMonth() + 1,
        month_char: this.datepipe.transform(date, "MMMM"),
        month_year: date.getFullYear(),
        user_id: this.data.data.id,
        kps_value: this.rating.toString(),
        pm_values: this.pm_rating.toString(),
        points: points,
        pm_points: pm_points,
        date: this.datepipe.transform(date, 'yyyy/MM/dd HH:mm:ss'),
        is_evaluation: publish ?? 0
      };
    }

    this.showSpinner = true
    this.evaluationService.addOrUpdateKPV(model).then(response => {
      this.showSpinner = false
      if (response.success) {

        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Evalaution Added Successfully!',
          showConfirmButton: false,
          timer: 3000,
        });

        this.router.navigate(['/evaluation-list']);
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }

    });
  }
  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_evaluation?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;

      case "add":
        return values?.add ?? false;

      case "update":
        return values?.update ?? false;


      default:
        return false;
    }
  }

  onCancel(form: NgForm) {
    form.reset();
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  navigateBack(): void {
    // Navigate back to the previous route stored in service
    const previousRoute = this.navigationEvaluationService.previousRoute || '/default-route';
    this.router.navigateByUrl(previousRoute);
  }


}
